import agent from "../../../api/agent";
export const getListByRolId = (pagerInputModel) =>  agent.requests.post(`/RoleMenu/getListByRolId`, pagerInputModel);
export const create = (RoleMenu)        => agent.requests.post(`/RoleMenu/create`, RoleMenu);
export const deleteItem = (RoleMenu)  => agent.requests.post(`RoleMenu/delete`, RoleMenu);

export const menulist = (pagerInputModel) =>  agent.requests.post(`/Menu/getList`, pagerInputModel);


